export const isEqual = (prev, current): boolean => JSON.stringify(prev) === JSON.stringify(current);
